<script>
import styleHOCFactory from './utils';
export default styleHOCFactory('pill');
</script>

<style module>
@import 'styles/variables.css';

._pill-style {
  composes: b--white ba fw6 from global;
  border-radius: 14px;
  font-size: 11px;
  line-height: 14px;
  fill: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* transition: background-color .2s ease-in-out; */
  &:hover {
    color: white;
    fill: white;
    background-color: transparent;
    box-shadow: 0 0 14px rgba(255,255,255,0.8);
  }
  &:global(.-active) {
    fill: black;
    background-color: white;
    color: black;
    /* &:hover {
      color: white;
      fill: white;
      background-color: transparent;
      box-shadow: 0 0 14px rgba(255,255,255,0.8);
    } */
  }
}
</style>
<style>
@import 'styles/variables.css';

._pill-style {
  & .icon-station-easy, & .icon-station-medium {
    fill-opacity:0.4;
    fill:white;
  }
  /* &:hover {
    & .icon-station-easy, & .icon-station-medium {
      fill-opacity:0.2;
      fill:black;
    }
  } */
  &.-active {
    & .icon-station-easy, & .icon-station-medium {
      fill-opacity:0.2;
      fill:black;
    }
    /* &:hover {
      & .icon-station-easy, & .icon-station-medium {
        fill-opacity:0.4;
        fill:white;
      }
    } */
  }
}
</style>
